import { includes } from 'lodash/fp';
import { PRODUCT_TYPE } from '@ahmdigital/constants';

const { COMBINED, HOSPITAL, PACKAGE } = PRODUCT_TYPE;

// @ts-expect-error - Automatic, Please fix when editing this file
const hasHospitalComponent = (product) => product && includes(product.type, [COMBINED, HOSPITAL, PACKAGE]);

export default hasHospitalComponent;
